<template>

<app-content-box :transparent="true" title="Your next event" :not-padded="true" icon="dashboard.next">

    <div class="event" v-tooltip="(data.event) ? false : 'Click to browse schedule'" v-on:click="onEventClick" :class="{'is-empty': !data.event, 'no-actions': !hasActions}">

        <template v-if="data.event">

            <div class="event-image" v-bgimage="data.event.image" />

            <div class="event-name">

                <div class="event-name-title">{{ data.event.name }}</div>
                <div class="event-name-countdown" v-if="isFuture">{{ $countdown(data.event.date + this.$con.offset) }}</div>

            </div>

            <div class="event-about">

                <div class="event-about-time">{{ $con.schedule.times[data.event.schedule.time] }} - {{ $con.schedule.times[data.event.schedule.time + data.event.schedule.duration] }}</div>
                <div class="event-about-players">{{ data.event.seats.available }} open seat<template v-if="data.event.seats.available !== 1">s</template></div>

            </div>

            <div class="event-location">{{ locationChange || data.event.location }}</div>

            <app-button v-on:click.native.stop="onLookingClick" v-if="canLook && data.event.session.can.look && !isLooking" :loading="is.looking" theme="white" text="Flag as needing player" icon="event.live.looking" v-tooltip="'Click to let people know you need a player'" class="event-button" />
            <app-button v-on:click.native.stop="onLookingClick" v-if="canLook && data.event.session.can.look && isLooking" :loading="is.looking" theme="red" text="Cancel needing player" icon="event.live.notlooking" v-tooltip="'Click if you no longer need a player'" class="event-button" />
            <app-button v-on:click.native.stop="onLocationClick" v-if="data.event.session.can.locate" theme="white" text="Update location" icon="event.live.location" v-tooltip="'Click to set location for event'" class="event-button" />

        </template>

        <template v-if="!data.event">

            <div class="event-empty">You don't have any upcoming events.<small>Click to browse schedule</small></div>

        </template>

        <com-location v-if="is.location" :event="data.event" v-on:close="is.location = false" v-on:change="onLocationChange" />

    </div>

</app-content-box>

</template>

<script>

import comLocation from '../common/panel/Location'

export default {

    props: ['data'],

    components: {
        'com-location': comLocation
    },

    data: function() {
    
        return {
            is: {
                location: false,
                looking: false
            },
            looking: null,
            locationChange: '',
            threshold: 600
        }

    },

    computed: {

        canLook: function() {
        
        
            return this.data.event.date > (this.$time - this.$con.offset) - this.threshold && this.data.event.date < (this.$time - this.$con.offset) + this.threshold

        },

        isLooking: function() {
        
            return (this.looking === null) ? this.data.event.looking : this.looking

        },

        hasActions: function() {

            if (!this.data.event) return false
        
            return (this.data.event.session.can.look && this.canLook) || this.data.event.session.can.locate
        
        },
    
        isFuture: function() {
        
            return this.data.event.date > this.$time
        
        },

        isCurrent: function() {
        
            return this.data.event.date < this.$time && this.data.event.date + this.data.event.duration > this.$time
        
        },

        isPast: function() {
        
            return this.data.event.date < this.$time
        
        }
    
    },

    methods: {

        onLookingClick: function() {
        
            this.is.looking = true

            this.$api.post(['convention/schedule/event', this.data.event.id, 'looking']).then(function(json) {

                this.looking = json.looking

                this.is.looking = false
            
            }.bind(this))

        },

        onLocationClick: function() {
        
            this.is.location = true

        },
    
        onEventClick: function() {

            if (this.is.location) return false
        
            if (this.data.event) {
            
                this.$router.push({
                    name: 'Convention.Schedule.Event',
                    params: {
                        id: this.data.event.id
                    }
                })

            } else {
            
                this.$router.push({
                    name: 'Convention.Schedule.Browse'
                })

            }
        
        },

        onLocationChange: function(value) {
        
            this.locationChange = value
        
        }
    
    }

}

</script>

<style scoped>

.event {
    background-color: #4082d3;
    color: #fff;
    grid-gap: 20px;
    height: 100%;
    padding: 20px;
    border-radius: 4px;
    min-height: 240px;
    cursor: pointer;
}

.is-mobile .event {
    margin-bottom: 15px;
}

.event.is-empty {
    cursor: pointer;
}

.event.is-empty:hover {
	background-color: #236dc9;
}

.event-image {
    height: 100px;
    min-height: calc(100% - 160px);
    width: calc(100% + 40px);
    margin-top: -20px;
    margin-left: -20px;
    border-radius: 4px 4px 0px 0px;
    margin-bottom: 10px;
    background-position: 50% 50%;
    background-size: cover;
}

.event.no-actions .event-image {
    height: 140px;
}

.is-mobile .event-image {
    height: 200px;
}

.event-empty {
    font-size: 20px;
    color: #fff;
    line-height: 24px;
    text-align: center;
    left: 0px;
    width: 100%;
    padding: 0px 40px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 500;
}

.event-empty small {
    font-size: 16px;
    line-height: 20px;
    margin-top: 5px;
    display: block;
    opacity: 0.5;
}

.event-prefix {
    font-size: 16px;
    font-weight: 400;
}

.event-name {
    padding-top: 5px;
    display: grid;
    grid-template-columns: auto 72px;
}

.event-name-title {
    font-size: 24px;
    line-height: 24px;
    font-weight: 500;
}

.event-name-countdown {
    text-align: center;
    font-size: 24px;
    line-height: 24px;
    font-weight: 400;
    font-family: "Red Hat Mono", monospace;
}

.event-about {
    display: grid;
    padding-top: 5px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 500;
    grid-template-columns: auto auto;
}

.event-location {
    padding: 5px 0px 5px 0px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 300;
}

.event.no-actions .event-location {
    padding-bottom: 0px;
}

.event-about-players {
    text-align: right;
}

.event-button {
    margin-top: 5px;
    text-align: left;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    padding: 10px 10px;
    width: 100%;
}

</style>
